import { Injectable } from '@angular/core';
import { ConfigMeta } from '../../models/meta';
import { ConfigurationService } from '../configuration/configuration.service';
import { QueryParamsHandling } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class GestionProvenanceService {
  constructor(private readonly configurationService: ConfigurationService) {}

  obtenirRouteExterne(): string | null {
    return this.configurationService.getValueOrNull(ConfigMeta.OEL_URL_RETOUR_EXTERNE);
  }

  estProvenanceExterne(): boolean {
    const routeExterne = this.obtenirRouteExterne();
    return routeExterne !== null && routeExterne.trim().length > 0;
  }

  obtenirValeurQueryParamsHandling(): QueryParamsHandling | null {
    if (this.estProvenanceExterne()) {
      return 'merge';
    }
    return null;
  }
}
